'use client';

import { useMemo } from 'react';
import { cn } from '@/app/utils';
import type { FeatureCardProps } from '../types';

function FeatureCard({ image, title, description, className }: FeatureCardProps) {
  return (
    <div className="flex flex-col items-center text-center md:px-4">
      <div
        className={cn(
          'mb-6 flex h-[124px] w-[124px] items-center justify-center rounded-full text-white md:mb-5 md:h-[93px] md:w-[93px]',
          className,
        )}
      >
        <img
          src={image}
          alt={title}
          width={84}
          height={84}
          className="h-[84px] w-[84px] md:h-[62px] md:w-[62px]"
          loading="lazy"
          decoding="async"
        />
      </div>
      <h3 className="mb-3 font-semibold text-[32px] leading-[1.4] md:mb-2 md:text-[24px]">{title}</h3>
      <p className="text-base text-gray-600 leading-[1.6] md:text-sm">{description}</p>
    </div>
  );
}

type FeatureProps = {
  className?: string;
  features: FeatureCardProps[];
};

export function Features({ features, className }: FeatureProps) {
  const featuresContent = useMemo(() => {
    return features.map((feature) => <FeatureCard key={feature.title} {...feature} />);
  }, [features]);
  return (
    <div className={className}>
      <div className="grid grid-cols-3 gap-[76px] px-[100px] md:grid-cols-1">{featuresContent}</div>
    </div>
  );
}
